import { breakpoints } from './variables';

const cards = {
	init() {
		this.cardGroups = document.querySelectorAll('.em-card-grid, .em-featured-blog');
		if (this.cardGroups.length) {
			this.setHeight = this.setHeight.bind(this);
			window.addEventListener('load', this.setHeight);
			window.addEventListener('resize', this.setHeight);
			window.addEventListener('orientationchange', this.setHeight);
		}
	},

	setHeight() {
		window.requestAnimationFrame(() => {
			this.cardGroups.forEach((cardGroup) => {
				const cards = cardGroup.querySelectorAll('.card');
				if (cards.length) {
					let height = 0;
					cards.forEach((card) => {
						// Store the card's height if it is taller than the previous value.
						height = card.offsetHeight > height ? card.offsetHeight : height;
						// Set the card's height accordingly.
						card.style.height = `${height}px`;
					});
					// Make cards the same height on screens where cards don't stack.
					if (breakpoints.xs.aboveMin()) {
						cards.forEach((card) => {
							card.style.height = `${height}px`;
						});
					}
				}
			});
		});
	},
};

cards.init();
